<p>view-on-map works!</p>
